import { getVirtualScreenshareParticipantOwnerId } from '../base/participants/functions';
export * from './functions.any';
/**
 * 获取当前应在右上角小窗展示的「正在共享屏幕」人员 ID（摄像头参与者，非虚拟共享参与者）。
 *
 * @param {IReduxState} state - Redux 状态。
 * @returns {string|undefined}
 */
export function getMobileScreensharePresenterId(state) {
    const { remoteScreenShares } = state['features/video-layout'];
    if (!remoteScreenShares?.length) {
        return undefined;
    }
    const latestScreenshareId = remoteScreenShares[remoteScreenShares.length - 1];
    return getVirtualScreenshareParticipantOwnerId(latestScreenshareId);
}
